import { getType } from 'typesafe-actions';
import { globalActions, GlobalActions } from './actions';
import { DEFAULT_CONFIG_OBJECT } from '@/components/dashboard/constants';
import themeData from './theme.json';

// `theme.json` nests the palette under a single top-level key, and the
// production bundler treats that key as a JSON module export it is free to
// rename. Read it by name while the name is still there, and otherwise fall
// back to the one palette the file holds, so the theme is never undefined.
const themeFile = themeData as Record<string, Record<string, any>>;
export const DEFAULT_THEME: Record<string, any> =
  themeFile.default ?? Object.values(themeFile)[0];

export interface commonGlobalState {
  globalConfig: object;
  dashboardPermission: object;
  theme: object;
  export_datas: any;
}

export const initialState: commonGlobalState = {
  globalConfig: DEFAULT_CONFIG_OBJECT,
  dashboardPermission: {},
  theme: DEFAULT_THEME,
  export_datas: {},
};

export const reducer = (
  state: commonGlobalState = initialState,
  action: GlobalActions,
): commonGlobalState => {
  switch (action.type) {
    case getType(globalActions.setConfig):
      // filter object
      return {
        ...state,
        globalConfig: action.payload,
      };
    case getType(globalActions.setDashboardPermission):
      return {
        ...state,
        dashboardPermission: action.payload,
      };
    case getType(globalActions.setTheme):
      return {
        ...state,
        theme: action.payload,
      };
    case getType(globalActions.setExport):
      return {
        ...state,
        export_datas: action.payload,
      };

    default:
      return state;
  }
};
